import * as React from "react";
import { Map } from "ol";
import { Layer } from "ol/layer";
import { useEffect, useRef } from "react";
import { useBaseMapContext } from "../../Contexts/BaseMapContext";
import { DragButton } from "./DragButton";

const pixelRatio = window.devicePixelRatio;

export const SplitControl = ({ map }: { map: Map }): JSX.Element => {
    const { height, setHeight, secondaryMapId } = useBaseMapContext();

    const dragRef = useRef<HTMLDivElement>();
    const heightRef = useRef<number>();
    const secondLayerRef = useRef<Layer>();

    useEffect(() => {
        return () => {
            setHeight(document.body.clientHeight / 2);

            if (secondLayerRef.current) {
                secondLayerRef.current.setVisible(false);
                secondLayerRef.current.setZIndex(0);
                secondLayerRef.current.un("prerender", onPreRender);
                secondLayerRef.current.un("postrender", onPostRender);
            }
        };
    }, []);

    useEffect(() => {
        heightRef.current = height * pixelRatio;
        secondLayerRef.current && secondLayerRef.current.changed();
        dragRef.current && ((dragRef.current as HTMLElement).style.top = document.body.clientHeight - height + "px");
    }, [height]);

    useEffect(() => {
        if (!secondaryMapId) {
            return;
        }

        //@ts-ignore
        secondLayerRef.current = map
            .getLayers()
            .getArray()
            .find((basemapLayer: Layer) => basemapLayer.get("id") === secondaryMapId);
        if (!secondLayerRef.current) {
            return;
        }

        secondLayerRef.current.setVisible(true);
        secondLayerRef.current.setZIndex(1);

        secondLayerRef.current.on("prerender", onPreRender);
        secondLayerRef.current.on("postrender", onPostRender);
    }, [secondaryMapId]);

    const onPreRender = (event) => {
        const ctx = event.context;
        ctx.save();
        ctx.beginPath();
        ctx.rect(0, ctx.canvas.height - heightRef.current, ctx.canvas.width, heightRef.current);
        ctx.clip();
    };

    const onPostRender = (event) => {
        const ctx = event.context;
        ctx.restore();
    };

    return (
        <div ref={dragRef} className="drag-container">
            <DragButton height={height} setHeight={setHeight}></DragButton>
        </div>
    );
};
